import React from 'react';
import Video from 'housecall-ui/dist/DesignSystem/DataDisplay/Video/Video';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import MojioIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/MojioIcon';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import MojioButton from '../OtherComponents/MojioButton';

const MojioStrategy = {
  previewInfo: {
    name: 'Mojio',
    iconSvg: <MojioIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Force by Mojio',
    category: 'Labs',
    details: (
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography paragraph>
            Force by Mojio is GPS vehicle tracking designed specifically for home
            services businesses like yours. Force helps you grow your business by
            improving your operations, serving your customers better and
            controlling your vehicle-related costs.
          </Typography>
          <Typography style={{ fontWeight: 'bold' }} display="inline">
            New!
          </Typography>
          {' '}
          <Typography paragraph display="inline">
            Impress your customers, save time, and grow your business even faster
            — by combining Force by Mojio with Housecall Pro. Watch the video
            below to learn more!
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Video src="https://player.vimeo.com/video/538887519" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">Using Force by Mojio with Housecall Pro</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            Give your customers the ability to track your Pros while they’re on
            the way to the job site — just like when they are waiting for an Uber
            to pick them up!
          </Typography>
          <Typography paragraph>
            With this integration, when your Pros tap “On My Way” in Housecall
            Pro, we automatically send a text message to your customer, providing
            them with a special link to temporarily view and track the vehicle on
            a map while they wait for the Pro to arrive.
          </Typography>
          <Typography>
            Surprise and delight your customers and generate positive
            word-of-mouth by providing a modern service that improves
            communication and reduces frustration. Best of all, your customers are
            more likely to stay home if they can see the vehicle on its way, and
            that means fewer missed appointments and lost revenue.
          </Typography>
          <Typography>
            Bonus: if your Pro is running late for any reason, the customer won’t
            need to call your office asking for an ETA.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <Link
              href="https://forcebymojio.com/lp/hcp-superpro/?utm_source=partner&utm_medium=housecallpro&utm_campaign=appstore"
              target="_blank"
              rel="noopener"
            >
              START YOUR FREE TRIAL TODAY
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">Why Force by Mojio?</Typography>
        </Grid>
        <Grid item xs={12}>
          <Video src="https://player.vimeo.com/video/464026217" />
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            At Force, we know how important your vehicles are. Keeping them
            running smoothly, holding your drivers accountable and controlling
            your costs are heavy burdens for any business owner.
          </Typography>
          <Typography paragraph>
            That’s why we built Force – to give you the information you need to
            make smart decisions about your vehicles, whether you’re at the
            office, in the field or at home. That way, you can focus on what
            matters most to you and your customers.
          </Typography>
          <Typography>
            We are the most small-business friendly GPS vehicle tracking product
            out there.
          </Typography>
          <ul>
            <li>Simple, all-in pricing: just $18/month per vehicle</li>
            <li>No extra charge for GPS devices — it’s all included</li>
            <li>No upfront costs</li>
            <li>No contracts, pay month-to-month</li>
            <li>No activation fees</li>
            <li>No hidden fees</li>
            <li>Free shipping</li>
          </ul>
        </Grid>
        <Grid item xs={12}>
          <Typography>Why else should you choose Force by Mojio?</Typography>
          <ul>
            <li>Keep track of your vehicles while you’re in the field with our iPhone & Android apps.</li>
            <li>Rely on us: our tech is trusted in over 1 million vehicles worldwide.</li>
            <li>Easy plug & play installation — takes less than 3 minutes per vehicle.</li>
            <li>Real time tracking — location refreshes every 10 sec. or less, the fastest in the industry.</li>
            <li>Friendly US-based phone & email support team.</li>
          </ul>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            Sign up now for our limited time special offer: 90 day FREE trial for
            SuperPros!
          </Typography>
          <Typography>
            Enter coupon code
            {' '}
            <Typography style={{ fontWeight: 'bold' }} display="inline">
              SUPERPRO2021
            </Typography>
            {' '}
            when signing up.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            <Link
              href="https://forcebymojio.com/lp/hcp-superpro/?utm_source=partner&utm_medium=housecallpro&utm_campaign=appstore"
              target="_blank"
              rel="noopener"
            >
              START YOUR FREE TRIAL TODAY
            </Link>
          </Typography>
        </Grid>
      </Grid>
    ),
    iconSvg: <MojioIcon size="xlarge" />,
  },
  media: {},
  sellingPoints: {},
  price: {
    price: '',
    hideToggle: true,
    appActionButton: <MojioButton />,
    description: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Typography align="right">
                $18 per vehicle, per month
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography color="secondary" align="right">
            Try Force for FREE for 90 days! Enter coupon code SUPERPRO2021 when
            signing up.
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [
    { type: 'Phone', contact: '806-855-8255' },
    {
      type: 'Support',
      contact: (
        <Link href="mailto:customerservice@forcebymojio.com">
          customerservice@forcebymojio.com
        </Link>
      ),
    },
  ],
};

export default MojioStrategy;
